import React from 'react';
import { motion } from 'framer-motion';

/** "Ask" in the languages a customer might arrive in. */
const WORDS = [{
  word: 'اسأل',
  label: 'العربية'
}, {
  word: 'Ask',
  label: 'English'
}, {
  word: 'Demander',
  label: 'Français'
}, {
  word: 'Preguntar',
  label: 'Español'
}, {
  word: 'Fragen',
  label: 'Deutsch'
}, {
  word: 'पूछें',
  label: 'हिन्दी'
}, {
  word: '问',
  label: '中文'
}, {
  word: 'Спросить',
  label: 'Русский'
}, {
  word: 'Sor',
  label: 'Türkçe'
}, {
  word: 'Tanya',
  label: 'Bahasa'
}, {
  word: '尋ねる',
  label: '日本語'
}, {
  word: 'Pergunte',
  label: 'Português'
}, {
  word: 'سؤال کریں',
  label: 'اردو'
}, {
  word: 'ถาม',
  label: 'ไทย'
}];
interface LanguageMarqueeProps {
  className?: string;
  /** Seconds for one full loop. */
  duration?: number;
}

/**
 * A continuous strip of the word "ask" across languages — the multilingual
 * claim stated as a visual rather than a bullet.
 */
export function LanguageMarquee({
  className = '',
  duration = 42
}: LanguageMarqueeProps) {
  const row = [...WORDS, ...WORDS];
  return <div className={`relative overflow-hidden ${className}`} aria-hidden="true" data-id="element-1778" data-mp="1n496i0idrvjh">
      <motion.div className="flex items-baseline gap-6 w-max" animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-1779" data-mp="1rxc028n5r4zo">
        {row.map((entry, index) => <span key={`${entry.label}-${index}`} className="flex items-baseline gap-2 shrink-0" data-id="element-1780" data-mp="1i70j9lidl1bd" data-mpi={index}>
            <span className="font-display font-bold text-[16px] text-dark-navy/70 leading-none" data-id="element-1781" data-mp="25x371pf9bl46">
              {entry.word}
            </span>
            <span className="text-[9px] uppercase tracking-[0.16em] text-slate-300" data-id="element-1782" data-mp="1vydy4m5c9b02">
              {entry.label}
            </span>
            <span className="w-1 h-1 rounded-full bg-primary-indigo/25 ml-4" data-id="element-1783" data-mp="20vxdxqhopvu4" />
          </span>)}
      </motion.div>

      {/* Fade the strip into the page at both ends */}
      <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent" data-id="element-1784" data-mp="pibr4bzas6br" />
      <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent" data-id="element-1785" data-mp="2s50a1je1tjgj" />
    </div>;
}